import styled from 'styled-components';

interface LabelIconProps {
  $small?: boolean;
}

export const LabelIcon = styled.img<LabelIconProps>`
  max-height: ${(props) => (props.$small ? '18px' : '23px')};
  margin-top: -6px;
  margin-bottom: -3px;
  vertical-align: middle;
`;
